import React, { useEffect, useState } from 'react';
import { object } from 'prop-types';
import { colorGrid } from 's2s-themes';
import Select from 's2s-select';
import styled from 'styled-components';
import { getIntlText } from '../js/utilities';
import useSettings from '../hooks/settings';

const SettingsContainer = styled.div`
  background-color: ${colorGrid.gray0};
  display: flex;
  flex-direction: column;
  font-family: Open Sans;
  padding: 24px 24px 0 24px;
`;
const SettingsTitle = styled.div`
  color: #001221;
  font-size: 14px;
  font-weight: 600;
  line-height: 12px;
  padding: 10px 0 15px 0;
`;
const SettingsDescription = styled.div`
  color: #4c5863;
  font-size: 14px;
  line-height: 12px;
  padding-bottom: 10px;
`;
const Delimiter = styled.div`
  border-bottom: 1px solid ${colorGrid.gray3};
  margin-bottom: 12px;
`;
const StyledSelect = styled(Select)`
  height: auto
  margin-bottom: 12px;
  
  .react-select__menu {
    width: 0;
  }
`;

const DeviceSettings = (props) => {
  const [settings, { changeSettings }] = useSettings();
  const [inputAudio, setInputAudio] = useState();
  const [outputAudio, setOutputAudio] = useState();

  const getAudio = async () => {
    //console.error('get audio is running ');
    const devices = await navigator.mediaDevices.enumerateDevices();

    const inputAudio = devices.filter((device) => {
      return device.kind === "audioinput"; // returns a InputDeviceInfo object which is read only
    }).map((device) => {
      // InputDeviceInfo is a read only object so I must create a new object so it can be successfully merged later on change
      return {
        "deviceId": device.deviceId,
        "groupId": device.groupId,
        "kind": device.kind,
        "label": device.label
      };
    });

    const outputAudio = devices.filter((device) => {
      return device.kind === "audiooutput"; // returns a MediaDeviceInfo object which is read-only
    }).map((device) => {
      // MediaDeviceInfo is a read only object so I must create a new object so it can be successfully merged later on change
      return {
        "deviceId": device.deviceId,
        "groupId": device.groupId,
        "kind": device.kind,
        "label": device.label
      };
    });

    setInputAudio(inputAudio);
    setOutputAudio(outputAudio);
  };
  const handleChangeInput = (input) => {
    changeSettings({ "selectedAudio": input }, props.intl);
  };
  const handleChangeOutput = (output) => {
    changeSettings({ "selectedSpeaker": output }, props.intl);
  };

  const inputDevices = inputAudio && inputAudio.map((device) => {
    return {
      "value": device.deviceId,
      "label": device.label
    };
  });
  const defaultInputDevice = inputDevices && inputDevices[0].value;
  const outputDevices = outputAudio && outputAudio.map((device) => {
    return {
      "value": device.deviceId,
      "label": device.label
    };
  });
  const defaultOutputDevice = outputDevices && outputDevices[0].value;

  useEffect(() => {
    getAudio(); // listening for devices on initial render
  }, []);

  return (
    <SettingsContainer className="DevicesSettingsContainer">
      <SettingsTitle className="DevicesSettingsTitleStyles" >
        {getIntlText(props.intl, 'SETTINGS-INPUT-DEVICE', "Input Device")}
      </SettingsTitle>
      <SettingsDescription className="DevicesSettingsDescriptionStyles" >
        {getIntlText(props.intl, 'SETTINGS-INPUT-DEVICE-DESCRIPTION', 'Set the input audio device you want to use.')}
      </SettingsDescription>
      <StyledSelect
        cbOnValueChange={handleChangeInput}
        menuItems={inputDevices ? inputDevices : []}
        selectedItem={settings && settings.selectedAudio && typeof settings.selectedAudio.value !== "undefined" ? settings.selectedAudio.value : defaultInputDevice}
      />
      <Delimiter />
      <SettingsTitle className="DevicesSettingsTitleStyles">
        {getIntlText(props.intl, 'SETTINGS-OUTPUT-DEVICE', "Output Device")}
      </SettingsTitle>
      <SettingsDescription className="DevicesSettingsDescriptionStyles">
        {getIntlText(props.intl, 'SETTINGS-OUTPUT-DEVICE-DESCRIPTION', 'Set the output audio device you want to use.')}
      </SettingsDescription>
      <StyledSelect
        cbOnValueChange={handleChangeOutput}
        menuItems={outputDevices ? outputDevices : []}
        selectedItem={settings && settings.selectedSpeaker && typeof settings.selectedSpeaker.value !== "undefined" ? settings.selectedSpeaker.value : defaultOutputDevice}
      />
    </SettingsContainer >
  );
};

DeviceSettings.propTypes = {
  intl: object
};

export default DeviceSettings;
